import React from "react";
import { Form, Row, Col, Card } from "react-bootstrap";

const IntervalsTab = ({
    form,
    setForm
}) => {

    const updateInterval = (key, value) => {

        setForm(prev => ({
            ...prev,
            intervals: {
                ...prev.intervals,
                [key]: value
            }
        }));

    };

    return (

        <>

            {/* HEADER */}

            <Card className="mb-3 border-0 bg-light">

                <Card.Body>

                    <strong>

                        Configuração de intervalos

                    </strong>

                    <div className="text-muted small">

                        Controle de tempo entre automações, atendentes e simulação de digitação.

                    </div>

                </Card.Body>

            </Card>

            {/* GRID */}

            <Row>

                {/* Intervalo de automação */}

                <Col md={4} className="mb-3">

                    <Form.Group>

                        <Form.Label>

                            Intervalo de automações

                        </Form.Label>

                        <Form.Control
                            type="number"
                            min={0}
                            value={form.intervals?.automation || 0}
                            onChange={(e) =>
                                updateInterval(
                                    "automation",
                                    Number(e.target.value)
                                )
                            }
                        />

                        <Form.Text className="text-muted">

                            Tempo entre execuções automáticas de mensagens.

                        </Form.Text>

                    </Form.Group>

                </Col>

                {/* Intervalo de atendentes */}

                <Col md={4} className="mb-3">

                    <Form.Group>

                        <Form.Label>

                            Intervalo de atendentes

                        </Form.Label>

                        <Form.Control
                            type="number"
                            min={0}
                            value={form.intervals?.attendant || 0}
                            onChange={(e) =>
                                updateInterval(
                                    "attendant",
                                    Number(e.target.value)
                                )
                            }
                        />

                        <Form.Text className="text-muted">

                            Tempo mínimo entre respostas humanas.

                        </Form.Text>

                    </Form.Group>

                </Col>

                {/* Intervalo de digitação */}

                <Col md={4} className="mb-3">

                    <Form.Group>

                        <Form.Label>

                            Simulação de digitação

                        </Form.Label>

                        <Form.Control
                            type="number"
                            min={0}
                            value={form.intervals?.typing || 0}
                            onChange={(e) =>
                                updateInterval(
                                    "typing",
                                    Number(e.target.value)
                                )
                            }
                        />

                        <Form.Text className="text-muted">

                            Tempo que o sistema simula "digitando..." antes de enviar mensagem.

                        </Form.Text>

                    </Form.Group>

                </Col>

            </Row>

        </>

    );

};

export default IntervalsTab;